<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :md="6" :sm="10">
            <a-form-item label="项目">
              <j-search-select-tag type="list" v-model="queryParam.projId"
                                   :trigger-change="true" dict="proj_project,name,id"
                                   placeholder="请选择项目"/>
            </a-form-item>
          </a-col> -->
          <a-col :md="5" :sm="8">
            <a-form-item label="项目编号">
              <a-input placeholder="请输入项目编号" v-model="queryParam.projNum"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.projectName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="客户名称">
              <j-search-select-tag type="list" v-model="queryParam.customer" 
                dict="biz_customer,name,id" 
                :async = "true"
                placeholder="请输入至少两个汉字查询"/>
            </a-form-item>
          </a-col>       
          <a-col :md="2" :sm="6">
            <a-form-item label="包含下级">
              <a-checkbox v-model="queryParam.includeSubCustomer">
              </a-checkbox>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="4" :sm="6">
            <a-form-item label="状态">
<!--              <j-dict-select-tag
                placeholder="请选择项目状态"
                v-model="queryParam.status"
                dictCode="bms_project_status">
              </j-dict-select-tag>-->
              <a-select v-model="queryParam.status" placeholder="选择状态" :getPopupContainer= "(target) => target.parentNode" style="width: 150px">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="50">签约中</a-select-option>
                <a-select-option value="51">合同审核中</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
            <a-col :md="8" :sm="12">
              <a-form-item label="保险公司" >
                <j-search-select-tag type="list" v-model="queryParam.insurer"
                                   dict="biz_insurance_company,name,code"
                                   placeholder="请选择保险公司"/>
              </a-form-item>
            </a-col>            

            <a-col :md="4" :sm="8">
              <a-form-item label="合同起期">
                <j-date placeholder="请选择合同起期" v-model="queryParam.agreementStartTime"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="合同止期">
                <j-date placeholder="请选择合同止期" v-model="queryParam.agreementEndTime" @change="handleEndDateChange"/>
                <a-checkbox @change="handleEndLessChange" :checked="isEndLess">长期</a-checkbox>
              </a-form-item>
            </a-col>

          </template>

          <a-col :md="3" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
              {{ toggleSearchStatus ? '收起' : '展开' }}
              <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
            </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'customerAgreementInfo:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('保险合同表')" v-has="'customerAgreementInfo:export'">导出</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel" v-has="'customerAgreementInfo:import'">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(downUrl+text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'customerAgreementInfo:edit'" v-show="record.status == projectStatus.SIGN_WAIT">
                <a @click="handleEdit(record)" >编辑</a>
              </a-menu-item>
              <a-menu-item v-has="'customerAgreementInfo:del'" v-show="record.status == projectStatus.SIGN_WAIT">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)" >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'customerAgreementInfo:commit'" v-show="record.status == projectStatus.SIGN_WAIT">
                <a @click="applyAgreement(record)">提交审核</a>
              </a-menu-item>

              <a-menu-item v-has="'customerAgreementInfo:return'" v-show="record.status == projectStatus.SIGN_AUDIT">
                <a @click="handleAuditReturn(record,projectStatus.SIGN_WAIT)">退回</a>
              </a-menu-item>
              <a-menu-item v-has="'customerAgreementInfo:auditPass'" v-show="record.status == projectStatus.SIGN_AUDIT">
                <a @click="handleAuditPass(record, projectStatus.SERVICING)">审核通过</a>
              </a-menu-item>
              <!-- <a-menu-item v-if="record.status == projectStatus.SERVICING && record.agreementEndTime != '长期'" v-has="'customerAgreementInfo:delay'">
                <a @click="updateEndDate(record)">延期</a>
              </a-menu-item> -->
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <customer-agreement-modal ref="modalForm" @ok="modalFormOk"></customer-agreement-modal>
    <a-modal v-model="modalVisible" title="退回原因" @ok="handleAuditRemarkOK">
        <label style="margin-bottom: 10px;display: block;">退回原因：</label>
        <a-textarea rows="3" maxlength="255" placeholder="请输入简要描述" v-model="auditRemark" :trigger-change="true" />
      </a-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CustomerAgreementModal from './modules/CustomerAgreementModal'
  import JDate from '@/components/jeecg/JDate'
  import { filterObj } from '@/utils/util'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {postAction} from '@/api/manage'
  import ProjectStatus from '../ProjectStatus'

  export default {
    name: 'CustomerAgreementList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      CustomerAgreementModal,
      JSelectDepart,
      JDate,
      JSearchSelectTag,
    },
    data () {
      return {
        description: '客户合同列表页面',
        disableMixinCreated: true,
        asyncLoadCustomer: true,
        newEndDate: '',
        modalVisible: false,
        updateId: '',
        isEndLess: false,
        projectStatus:{},
        currentRecord: null,
        auditRemark: null,
        downUrl:window._CONFIG['downloadUrl'],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目编号',
            className:'column-text',
            dataIndex: 'projNum',
            sorter: true
          },
          {
            title:'项目名称',
            className:'column-text',
            dataIndex: 'projectName'
          },
          {
            title:'状态',
            className:'column-text',
            dataIndex: 'statusName',
          },
          {
            title:'合同名称',
            className:'column-text',
            dataIndex: 'agreementName'
          },
          {
            title:'保险公司',
            className:'column-text',
            dataIndex: 'insurerName'
          },
          {
            title:'客户',
            className:'column-text',
            dataIndex: 'customerName'
          },  
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy'
          },
          {
            title:'合同起期',
            className:'column-text',
            dataIndex: 'agreementStartTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'合同止期',
            className:'column-text',
            dataIndex: 'agreementEndTime',
            customRender:function (text) {
              if(text =='2099-12-31 23:59:59'){
                return '长期'
              }
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'合同附件',
            className:'column-text',
            dataIndex: 'agreementFile',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title:'提交人',
            className:'column-text',
            dataIndex: 'committerName'
          },
          {
            title:'提交时间',
            className:'column-text',
            dataIndex: 'commitTime'
          },
          {
            title:'审核人',
            className:'column-text',
            dataIndex: 'auditorName'
          },
          {
            title:'审核时间',
            className:'column-text',
            dataIndex: 'auditTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/project/customerAgreement/list",
          delete: "/project/customerAgreement/delete",
          deleteBatch: "/project/customerAgreement/deleteBatch",
          exportXlsUrl: "/project/customerAgreement/exportXls",
          importExcelUrl: "project/customerAgreement/importExcel",
          // 提交、审核
          changeStatus: "/project/customerAgreement/changeStatus",
        },
      }
    },
    created() {
      this.projectStatus = ProjectStatus // 引用常量
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        if(param.agreementStartTime){
          param.agreementStartTime = param.agreementStartTime + ' 00:00:00' //起始日期添加0
        }
        if(param.agreementEndTime){
          param.agreementEndTime = param.agreementEndTime + ' 23:59:59' //起始日期添加0
        } else if(this.isEndLess){
          param.agreementEndTime = '2099-12-31 23:59:59'
        }

        param.field = this.getQueryField()
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param)
      },
      
      handleRuleChange(item, newValue) {
        let oldValue = item.rule
        this.$set(item, 'rule', newValue)
        // 上一个规则是否是 in，且type是字典或下拉
        if (oldValue === 'in') {
          if (item.dictCode || item.options instanceof Array) {
            let value = item.val
            if (typeof item.val === 'string') {
              value = item.val.split(',')[0]
            } else if (Array.isArray(item.val)) {
              value = item.val[0]
            }
            this.$set(item, 'val', value)
          }
        }
      },
      // 提交审核
      applyAgreement(record){
        let param = {id: record.id, status: ProjectStatus.SIGN_AUDIT}
        postAction(this.url.changeStatus, param).then((res) =>{
          if(res.success){
            this.$message.success("提交成功")
            this.loadData()
          }else{
            this.$message.error("提交失败：" + res.message)
          }
        })
      },

      // 退回
      handleAuditReturn(record){
        this.auditRemark=''
        this.currentRecord = record
        this.modalVisible = true  
      },

      handleAuditRemarkOK(){
        if(this.auditRemark.length<=0){
          this.$message.warn("退回原因不能为空")
          return
        } else if(this.auditRemark.length >255){
          this.$message.warn("退回原因长度不能超过255个字符")
          return
        }
        this.modalVisible = false;
        this.auditAgreement(this.currentRecord, ProjectStatus.SIGN_WAIT, this.auditRemark)
      },

      handleAuditPass(record,status){
        this.auditAgreement(record, status, '')
      },

      // 审核
      auditAgreement(record, status, auditRemark){
        let param = {id: record.id, status: status, auditRemark: auditRemark}
        postAction(this.url.changeStatus, param).then((res) =>{
          if(res.success){
            if(status === ProjectStatus.SIGN_WAIT){
              this.$message.success("退回成功")
            } else {
              this.$message.success("审核通过成功")
            }
            this.loadData()
          }else{
            this.$message.error("审核失败：" + res.message)
          }
        })
      },

      handleEndDateChange(value){
        // if(value != null && value.trim() != ''){
        // }
        this.isEndLess = false
        //this.queryParam.agreementEndTime = value; //控件默认赋值
      },
      // 长期按钮
      handleEndLessChange(event){
        if(event && event.target.checked){
          this.isEndLess = true;
          this.queryParam.agreementEndTime = null;
        } else{
          this.isEndLess = false
        }
      },

    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>